import { render } from "./sound-on.svg?vue&type=template&id=46f50a24"
const script = {}

import exportComponent from "/buddy/stephen-webster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__